import React from 'react';
import {
  Box, Container, Skeleton, Stack, Typography,
} from '@mui/material';
import { TripMatch } from '@marageti/z4-sdk/lib/travel';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { InfiniteScroll } from '@marageti/z4-lib';
import AllCard from '../../../components/list-cards/trip-match-cards/all-card';
import AgentTripsFilters from './agent-trips-filter';

type AgentTripsViewProps = {
  error?: ApiError,
  hasMoreItems: boolean,
  isLoading: boolean,
  items?: TripMatch[],
  loadMore: () => void,
  onChangeFilter: (name: string, value: string | string[]) => void,
  searchValue: string,
  selectedStatusChips: string[],
  sortBy: { field: string, order: string },
  totalHits: string,
};

const AgentTripsView = ({
  error = undefined,
  hasMoreItems,
  isLoading,
  items = undefined,
  loadMore,
  onChangeFilter,
  searchValue,
  selectedStatusChips,
  sortBy,
  totalHits,
}: AgentTripsViewProps) => (
  <Container maxWidth="xl">
    <Box sx={{ mt: { desktop: 2.5, mobile: 3 } }}>
      <AgentTripsFilters
        onChange={onChangeFilter}
        searchValue={searchValue}
        selectedStatusChips={selectedStatusChips}
        sortBy={sortBy}
        disableSortBy={searchValue.length > 0}
      />

      {isLoading ? (
        <Skeleton variant="rounded" sx={{ mb: 2, height: '24px', width: '100px' }} />
      ) : (
        <Typography variant="bodyBold" mb={2}>
          {`${totalHits === '10,000' ? `${totalHits}+` : totalHits} Result${totalHits === '1' ? '' : 's'}`}
        </Typography>
      )}

      <Stack spacing={1}>
        <InfiniteScroll
          error={error}
          hasMoreItems={hasMoreItems}
          isLoading={isLoading}
          loadMoreItems={loadMore}
        >
          {items?.map((item: TripMatch) => (
            <AllCard
              key={item.id}
              tripMatch={item}
            />
          ))}
        </InfiniteScroll>
      </Stack>
    </Box>
  </Container>
);

export default AgentTripsView;
